function BlockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      data-name="BlockIcon - Block"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        d="M10 2a8 8 0 108 8 8 8 0 00-8-8zm-6.4 8A6.4 6.4 0 0110 3.6a6.322 6.322 0 013.92 1.352L4.952 13.92A6.322 6.322 0 013.6 10zm6.4 6.4a6.322 6.322 0 01-3.92-1.352l8.968-8.968A6.322 6.322 0 0116.4 10a6.4 6.4 0 01-6.4 6.4z"
        data-name="Path 10608"
        transform="translate(-2 -2)"
      ></path>
    </svg>
  );
}

export default BlockIcon;
